import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StructuredData from '../../components/feature/StructuredData';

export default function Nouchi() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://hudosan-shobun.com";

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '農地処分の方法｜相続した田んぼ・畑を手放したい方へ｜愛知県の弁護士';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '相続した農地（田・畑）が売れない、手放したいとお悩みの方へ。農地法の規制対応、農業委員会への許可申請、相続土地国庫帰属制度まで弁護士がサポート。愛知・岐阜・三重・静岡対応。初回相談無料。');
    }
  }, []);

  const handleFormClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const handleFormClickCTA = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const handleLineClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "農地が遠方にあり、現地に行けません。対応してもらえますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "はい。現地調査や農業委員会との交渉も含めて対応可能です。愛知・岐阜・三重・静岡の農地に対応しています。"
        }
      },
      {
        "@type": "Question",
        "name": "長年放置していて草が生い茂っています。それでも処分できますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "可能です。状況によっては非農地証明を取得して地目変更する方法もあります。まずは現況を確認させてください。"
        }
      },
      {
        "@type": "Question",
        "name": "不動産会社に断られました。弁護士なら対応できますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "農地は農地法の規制があるため、一般の不動産会社では対応できないケースが多いです。弁護士であれば、法的手続きを含めて対応可能です。"
        }
      },
      {
        "@type": "Question",
        "name": "国庫帰属制度は自分でも申請できますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "ご自身での申請も可能ですが、土地改良区との交渉や要件の確認など専門的な判断が必要な場面があります。当事務所でサポートすることもできます。"
        }
      },
      {
        "@type": "Question",
        "name": "費用はどのくらいかかりますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "処分方法や農地の状況によって異なります。初回相談は無料ですので、まずはご相談ください。"
        }
      },
      {
        "@type": "Question",
        "name": "相談だけでも大丈夫ですか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "はい。初回相談は無料です。ご依頼を強制することはありません。"
        }
      }
    ]
  };

  const legalServiceData = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "農地処分サポート｜名古屋の弁護士",
    "description": "相続した田んぼや畑が売れない、手放したいとお悩みの方へ。農地法の規制、農業委員会への対応、国庫帰属制度の申請まで弁護士がサポートします。",
    "url": siteUrl + "/nouchi",
    "areaServed": ["愛知県", "岐阜県", "三重県", "静岡県"],
    "priceRange": "初回相談無料",
    "provider": {
      "@type": "LegalService",
      "name": "冨田・島岡法律事務所",
      "telephone": "052-588-0874"
    }
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "ホーム",
        "item": siteUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "農地処分",
        "item": siteUrl + "/nouchi"
      }
    ]
  };

  const webPageData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "農地処分の方法｜相続した田んぼ・畑を手放したい方へ",
    "description": "相続した農地（田・畑）を処分する方法を弁護士が解説。農地法の規制、農業委員会への対応、国庫帰属制度の申請までサポート。",
    "url": siteUrl + "/nouchi",
    "isPartOf": {
      "@type": "WebSite",
      "name": "冨田・島岡法律事務所",
      "url": siteUrl
    },
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": ["h1", "h2", ".hero-description"]
    }
  };

  return (
    <>
      <StructuredData data={faqData} />
      <StructuredData data={legalServiceData} />
      <StructuredData data={breadcrumbData} />
      <StructuredData data={webPageData} />
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-orange-50 via-white to-orange-50">
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6">
                <i className="ri-plant-line text-orange-600"></i>
                <span className="text-sm font-medium text-orange-800">農地処分専門</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                相続した農地（田んぼ・畑）を<br className="md:hidden" />処分する方法
              </h1>
              <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                田んぼや畑が売れない、手放したいとお悩みの方へ。<br />
                農地法の規制、農業委員会への対応、国庫帰属制度の申請まで弁護士がサポートします。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:0525880874" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange-600 text-white rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line text-xl"></i>
                  052-588-0874
                </a>
                <a 
                  href="https://forms.gle/zPw2NXXr6K7nXgAm6" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  onClick={handleFormClick}
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-orange-600 border-2 border-orange-600 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line text-xl"></i>
                  メールで相談
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Concerns Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              こんなお悩みはありませんか？
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                '相続した田んぼや畑を手放したいが、引き取り手が見つからない',
                '農地を相続したが、自分は農業をする予定がない',
                '不動産会社に相談したが「農地は扱えない」と断られた',
                '毎年の草刈りや水利費の負担から解放されたい',
                '農地が遠方にあり、管理ができない',
                '固定資産税や維持費だけがかかっている状態をなんとかしたい'
              ].map((concern, index) => (
                <div key={index} className="flex items-start gap-4 p-6 bg-orange-50 rounded-xl">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-fill text-orange-600 text-xl"></i>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{concern}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Difficult Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              農地の処分はなぜ難しいのか
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-xl shadow-sm">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                  <i className="ri-file-list-3-line text-orange-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">農地法による厳しい規制</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  農地は食料生産の基盤として法律で保護されており、売却・譲渡には農業委員会の許可が必要です。
                </p>
                <p className="text-gray-600 leading-relaxed">
                  原則として農業従事者にしか売却できないという制約があります。
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-sm">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                  <i className="ri-user-search-line text-orange-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">引き取り手が限られる</h3>
                <p className="text-gray-600 leading-relaxed">
                  農家の高齢化・後継者不足により、タダでも引き取り手が見つからないケースが増えています。
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-sm">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                  <i className="ri-money-dollar-circle-line text-orange-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">維持費用がかかり続ける</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start gap-2">
                    <span className="text-orange-600 mt-1">•</span>
                    <span>固定資産税、水利費：年間数千円～数万円</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-orange-600 mt-1">•</span>
                    <span>草刈り費用：年間3万円～10万円程度</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-orange-600 mt-1">•</span>
                    <span>不法投棄の撤去費用：数十万円～100万円以上</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-orange-600 mt-1">•</span>
                    <span>災害時の損害賠償リスク</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Check First Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              まず確認すべきこと――農地の区分と現況
            </h2>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">農地区分によって処分方法が変わる</h3>
              <p className="text-gray-600 leading-relaxed mb-8">
                農地は立地や条件によって以下の5つに区分され、区分によって処分の選択肢が異なります。
              </p>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white shadow-sm rounded-lg overflow-hidden">
                  <thead>
                    <tr className="bg-orange-600 text-white">
                      <th className="px-6 py-4 text-left font-semibold">農地区分</th>
                      <th className="px-6 py-4 text-left font-semibold">転用の可否</th>
                      <th className="px-6 py-4 text-left font-semibold">特徴</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 font-medium text-gray-900">農用地区域内農地（青地）</td>
                      <td className="px-6 py-4 text-red-600 font-semibold">原則不可</td>
                      <td className="px-6 py-4 text-gray-600">農業振興地域内の農地。最も規制が厳しい</td>
                    </tr>
                    <tr className="border-b border-gray-200 bg-gray-50">
                      <td className="px-6 py-4 font-medium text-gray-900">甲種農地</td>
                      <td className="px-6 py-4 text-red-600 font-semibold">原則不可</td>
                      <td className="px-6 py-4 text-gray-600">市街化調整区域内の優良農地</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 font-medium text-gray-900">第1種農地</td>
                      <td className="px-6 py-4 text-red-600 font-semibold">原則不可</td>
                      <td className="px-6 py-4 text-gray-600">10ヘクタール以上の集団農地</td>
                    </tr>
                    <tr className="border-b border-gray-200 bg-gray-50">
                      <td className="px-6 py-4 font-medium text-gray-900">第2種農地</td>
                      <td className="px-6 py-4 text-orange-600 font-semibold">条件付きで可能</td>
                      <td className="px-6 py-4 text-gray-600">市街地近郊の農地</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 font-medium text-gray-900">第3種農地</td>
                      <td className="px-6 py-4 text-green-600 font-semibold">転用しやすい</td>
                      <td className="px-6 py-4 text-gray-600">市街地内または市街地に近い農地</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div className="mt-8 p-6 bg-orange-50 rounded-xl">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-2">
                      <strong>市街化区域内の農地</strong>であれば、届出のみで宅地として売却できる可能性があります。
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      <strong>農振農用地（青地）や第1種農地</strong>は農地としての処分が基本となります。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">すでに山林化している場合は「非農地証明」が必要</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                長期間放置されて山林化している農地は、「非農地証明」を取得して地目を変更することで処分しやすくなる場合があります。
              </p>
              <div className="p-6 bg-gray-50 rounded-xl">
                <h4 className="font-bold text-gray-900 mb-3">非農地証明とは</h4>
                <p className="text-gray-600 leading-relaxed">
                  農業委員会が「この土地はもはや農地ではない」と証明する書類です。これにより、農地法の規制を受けずに売却や地目変更が可能になります。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Five Methods Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              農地を処分する5つの方法
            </h2>
            <div className="space-y-8">
              {[
                {
                  icon: 'ri-user-heart-line',
                  title: '地元の農家に売却・譲渡する',
                  description: '農業委員会や農協を通じて地元の農家を紹介してもらう方法です。',
                  merit: '農地法の要件を満たしやすく、最も一般的な方法',
                  demerit: '引き取り手が見つからないことも多い。価格は期待できない',
                  suitable: '地元に農業を続けたい人がいる場合'
                },
                {
                  icon: 'ri-home-gear-line',
                  title: '農地転用して宅地等として売却する',
                  description: '第2種・第3種農地であれば、農地転用の許可を得て宅地や事業用地として売却できる可能性があります。',
                  merit: '宅地として売却できれば高値で売れる可能性がある。太陽光発電用地としての需要もある',
                  demerit: '転用許可の取得には手続きと費用がかかる。青地や第1種農地は転用不可',
                  suitable: '市街地に近い農地、太陽光発電に適した立地'
                },
                {
                  icon: 'ri-government-line',
                  title: '相続土地国庫帰属制度を利用する',
                  description: '2023年4月に開始した制度で、一定の要件を満たせば農地を国に返納できます。',
                  merit: '確実に手放せる。農地は建物がないため要件を満たしやすい',
                  demerit: '審査手数料（14,000円/筆）と負担金（20万円～）が必要。土地改良区の賦課金がある場合は事前に脱退交渉が必要',
                  suitable: '他の方法で処分できない農地。維持費負担から解放されたい場合',
                  link: true
                },
                {
                  icon: 'ri-exchange-line',
                  title: '農地中間管理機構（農地バンク）を利用する',
                  description: '農地を貸し出して賃料を得る方法です。',
                  merit: '所有権を手放さずに活用できる。賃料収入が得られる',
                  demerit: '処分ではなく活用。借り手が見つからない場合もある',
                  suitable: '将来的に農地を残したい場合。賃料収入を得たい場合'
                },
                {
                  icon: 'ri-close-circle-line',
                  title: '相続放棄する',
                  description: '相続発生から3か月以内であれば相続放棄という選択肢もあります。',
                  merit: '農地の負担から完全に解放される',
                  demerit: '農地だけを放棄することはできず、他の財産も含めて全て放棄する必要がある。期限が厳格（3か月以内）',
                  suitable: '相続財産全体がマイナスの場合。他に相続したい財産がない場合'
                }
              ].map((method, index) => (
                <div key={index} className="bg-white p-8 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl flex-shrink-0">
                      <i className={`${method.icon} text-orange-600 text-2xl`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3">{index + 1}. {method.title}</h3>
                      <p className="text-gray-600 leading-relaxed mb-4">{method.description}</p>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="p-4 bg-green-50 rounded-lg">
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-green-600 text-lg mt-0.5"></i>
                        <div>
                          <p className="font-semibold text-green-900 mb-1">メリット</p>
                          <p className="text-sm text-green-800">{method.merit}</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 bg-red-50 rounded-lg">
                      <div className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-red-600 text-lg mt-0.5"></i>
                        <div>
                          <p className="font-semibold text-red-900 mb-1">デメリット</p>
                          <p className="text-sm text-red-800">{method.demerit}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 bg-orange-50 rounded-lg">
                    <p className="text-sm text-gray-700">
                      <strong className="text-orange-900">向いているケース：</strong>{method.suitable}
                    </p>
                  </div>
                  {method.link && (
                    <div className="mt-4">
                      <Link to="/blog/sozo-tochi-kokko-kizoku" className="inline-flex items-center gap-2 text-orange-600 hover:text-orange-700 font-medium cursor-pointer">
                        <span>相続土地国庫帰属制度について詳しく見る</span>
                        <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Lawyer Benefits Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              農地処分を弁護士に依頼するメリット
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[
                {
                  icon: 'ri-scales-3-line',
                  title: '農地法の規制を踏まえた最適な処分方法を提案できる',
                  description: '農地区分の確認、転用可能性の判断、非農地証明の要否など、法的な観点から最適な方法を提案します。'
                },
                {
                  icon: 'ri-government-line',
                  title: '農業委員会との交渉・許可申請を代行できる',
                  description: '農地の売却・転用には農業委員会の許可が必要です。許可申請の書類作成や交渉を弁護士が代行します。'
                },
                {
                  icon: 'ri-file-text-line',
                  title: '契約書作成・トラブル対応ができる',
                  description: '個人間売買やマッチングサイト利用時の契約書作成、トラブル発生時の対応は弁護士の専門領域です。'
                },
                {
                  icon: 'ri-hand-heart-line',
                  title: '国庫帰属制度の申請をサポートできる',
                  description: '土地改良区との脱退交渉、申請書類の作成、法務局との調整など、複雑な手続きをサポートします。'
                }
              ].map((benefit, index) => (
                <div key={index} className="flex items-start gap-4 p-6 bg-orange-50 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-600 text-white rounded-xl flex-shrink-0">
                    <i className={`${benefit.icon} text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Support & Pricing Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              当事務所のサポート内容と費用
            </h2>
            <div className="bg-white p-8 md:p-12 rounded-xl shadow-sm">
              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">サポート内容</h3>
                  <ul className="space-y-3">
                    {[
                      '農地の現況調査・区分確認',
                      '最適な処分方法のご提案',
                      '農業委員会への許可申請代行',
                      '非農地証明の取得サポート',
                      '土地改良区との脱退交渉',
                      '国庫帰属制度の申請サポート',
                      '売買契約書の作成・チェック',
                      'トラブル発生時の対応'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-orange-600 text-lg mt-0.5"></i>
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">費用</h3>
                  <div className="space-y-4">
                    <div className="p-4 bg-orange-50 rounded-lg">
                      <p className="font-bold text-orange-900 mb-2">初回相談</p>
                      <p className="text-2xl font-bold text-orange-600">無料</p>
                    </div>
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <p className="font-bold text-gray-900 mb-2">着手金（受任時）</p>
                      <p className="text-3xl font-bold text-gray-900">0円</p>
                    </div>
                    <div className="p-4 bg-orange-50 rounded-lg">
                      <p className="font-bold text-orange-900 mb-2">成功報酬（登記完了時）</p>
                      <p className="text-3xl font-bold text-orange-600">110万円</p>
                      <p className="text-sm text-gray-600 mt-2">※処分に至らなかった場合、成功報酬は発生しません</p>
                    </div>
                  </div>
                  <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                    <p className="text-sm font-semibold text-blue-900 mb-2">料金に含まれる内容</p>
                    <ul className="text-sm text-blue-800 space-y-1">
                      <li>• 弁護士による調査・方針立案</li>
                      <li>• 農業委員会・譲受希望者との交渉</li>
                      <li>• 契約書案の作成</li>
                    </ul>
                  </div>
                  <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                    <p className="text-sm font-semibold text-gray-900 mb-2">別途発生しうる費用</p>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• 測量・境界確定・取り壊し費用（必要な場合）</li>
                      <li>• 登記実費</li>
                    </ul>
                  </div>
                  <p className="text-xs text-gray-500 mt-4 leading-relaxed">
                    ※隣接する3筆までが基本料金です。<br />
                    ※近隣（2km以内）の土地は8割の料金で追加対応いたします。<br />
                    ※実費（登記費用、測量費用など）は別途必要です。
                  </p>
                </div>
              </div>
              <div className="pt-8 border-t border-gray-200">
                <p className="text-center text-gray-600 leading-relaxed">
                  初回相談は無料です。まずはお気軽にご相談ください。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Flow Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              解決までの流れ
            </h2>
            <div className="space-y-6">
              {[
                {
                  step: '01',
                  title: 'お問い合わせ・初回相談（無料）',
                  description: 'お電話、メール、LINEでお気軽にご相談ください。農地の状況、お悩みをお聞かせください。'
                },
                {
                  step: '02',
                  title: '農地の調査（区分・現況の確認）',
                  description: '農地の区分、現況、権利関係を調査します。必要に応じて現地調査も行います。'
                },
                {
                  step: '03',
                  title: '処分方法の検討・提案',
                  description: '調査結果をもとに、最適な処分方法をご提案します。費用のお見積りもこの段階でお示しします。'
                },
                {
                  step: '04',
                  title: '農業委員会への許可申請・交渉',
                  description: '農地の売却・転用に必要な許可申請を代行します。農業委員会との交渉も弁護士が行います。'
                },
                {
                  step: '05',
                  title: '売買契約または国庫帰属申請',
                  description: '買主が見つかれば売買契約を締結します。国庫帰属制度を利用する場合は法務局への申請を行います。'
                },
                {
                  step: '06',
                  title: '処分完了',
                  description: '所有権移転登記が完了し、農地の処分が完了します。'
                }
              ].map((flow, index) => (
                <div key={index} className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 flex items-center justify-center bg-orange-600 text-white rounded-full font-bold text-lg">
                      {flow.step}
                    </div>
                  </div>
                  <div className="flex-1 pt-2">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{flow.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{flow.description}</p>
                  </div>
                  {index < 5 && (
                    <div className="flex-shrink-0 ml-8">
                      <i className="ri-arrow-down-line text-orange-600 text-2xl"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              よくあるご質問
            </h2>
            <div className="space-y-6">
              {faqData.mainEntity.map((faq, index) => (
                <div key={index} className="bg-white p-8 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-orange-600 text-white rounded-full font-bold flex-shrink-0">
                      Q
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 pt-1">{faq.name}</h3>
                  </div>
                  <div className="flex items-start gap-4 ml-14">
                    <div className="w-10 h-10 flex items-center justify-center bg-orange-100 text-orange-600 rounded-full font-bold flex-shrink-0">
                      A
                    </div>
                    <p className="text-gray-600 leading-relaxed pt-2">{faq.acceptedAnswer.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 関連ページへの誘導 */}
        <section className="py-12 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-xl font-bold text-gray-900 text-center mb-6">
              その他のお悩みはこちら
            </h2>
            <div className="grid md:grid-cols-3 gap-4">
              <Link
                to="/kyoyu-meigi"
                className="bg-gray-50 rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-group-line text-orange-500 text-xl"></i>
                  <h3 className="font-bold text-gray-900">共有名義・相続未分割</h3>
                </div>
                <p className="text-sm text-gray-600">共有者との交渉から共有物分割請求まで</p>
              </Link>
              
              <Link
                to="/blog/sanrin-syobun-5-houhou"
                className="bg-gray-50 rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-plant-line text-orange-500 text-xl"></i>
                  <h3 className="font-bold text-gray-900">山林処分</h3>
                </div>
                <p className="text-sm text-gray-600">山林を処分する5つの方法を解説</p>
              </Link>
              
              <Link
                to="/blog/kokko-kizon-shinsei-houhou"
                className="bg-gray-50 rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-government-line text-orange-500 text-xl"></i>
                  <h3 className="font-bold text-gray-900">国庫帰属制度</h3>
                </div>
                <p className="text-sm text-gray-600">申請方法と必要書類を詳しく解説</p>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              ご相談はこちら
            </h2>
            <p className="text-xl text-orange-100 mb-4 leading-relaxed">
              初回相談は無料です。まずはお気軽にご相談ください。
            </p>
            <p className="text-orange-100 mb-12 flex items-center justify-center">
              <i className="ri-time-line mr-2"></i>
              3営業日以内に心を込めてお返事いたします
            </p>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <a href="tel:0525880874" className="flex flex-col items-center gap-4 p-8 bg-white rounded-xl hover:shadow-xl transition-shadow cursor-pointer">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full">
                  <i className="ri-phone-line text-orange-600 text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900 mb-2">お電話でのご相談</p>
                  <p className="text-2xl font-bold text-orange-600">052-588-0874</p>
                  <p className="text-sm text-gray-600 mt-2">平日 9:00～18:00</p>
                </div>
              </a>
              <a 
                href="https://forms.gle/zPw2NXXr6K7nXgAm6" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={handleFormClickCTA}
                className="flex flex-col items-center gap-4 p-8 bg-white rounded-xl hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full">
                  <i className="ri-mail-line text-orange-600 text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900 mb-2">メールでのご相談</p>
                  <p className="text-orange-600 font-semibold">24時間受付</p>
                  <p className="text-sm text-gray-600 mt-2">2営業日以内に返信</p>
                </div>
              </a>
              <a href="https://lin.ee/34dhahY" target="_blank" rel="noopener noreferrer" onClick={handleLineClick} className="flex flex-col items-center gap-4 p-8 bg-white rounded-xl hover:shadow-xl transition-shadow cursor-pointer">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full">
                  <i className="ri-message-3-line text-orange-600 text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900 mb-2">LINEでのご相談</p>
                  <p className="text-orange-600 font-semibold">24時間受付</p>
                  <p className="text-sm text-gray-600 mt-2">お気軽にメッセージを</p>
                </div>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
